import { useContext, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { generatePath, Outlet, useParams } from 'react-router-dom';

import { BreadcrumbLevelContext, useBreadcrumb } from './breadcrumb-context';

interface RouteBreadcrumb {
  readonly labelKey: string;
  readonly href?: string;
}

interface BreadcrumbRouteConfigProps {
  readonly crumb: RouteBreadcrumb;
}

const BreadcrumbRouteConfig = ({ crumb }: BreadcrumbRouteConfigProps) => {
  const { addCrumb, removeCrumb } = useBreadcrumb();
  const { t } = useTranslation();
  const params = useParams();
  const level = useContext(BreadcrumbLevelContext);
  const id = useRef(Symbol());
  const label = t(crumb.labelKey);
  const href = crumb.href ? generatePath(crumb.href, params) : undefined;

  useEffect(() => {
    const currentId = id.current;
    addCrumb(currentId, level, { label, href });
    return () => removeCrumb(currentId);
  }, [label, href, addCrumb, removeCrumb, level]);

  return (
    <BreadcrumbLevelContext.Provider value={level + 1}>
      <Outlet />
    </BreadcrumbLevelContext.Provider>
  );
};

export { BreadcrumbRouteConfig };
